import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputUploader from "../../helpers/InputUploader";


function SupportNew(props)
{

    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        temat:  "",
        tresc: "",
        crypt: "",     
    });



    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const saveData = () => {


        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

        const dOd = Date.parse(row.data_od);
        const dDo = Date.parse(row.data_do);

        if(dOd > dDo)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Błędny przedział czasu, popraw daty" ,  "ok"  ,null); 
            return; 
        }
        
 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1,support_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Zgłoszenie zostało wysłane" , "ok" , null);                                              
                    
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {
        if(view == 'btn') 
        {
            setView("dlg"); 

            setRow({
                temat:  "",
                tresc: "",

                crypt1: "",    
                nazwa1: "",   

                crypt2: "",    
                nazwa2: "",   

                crypt3: "",    
                nazwa3: "",   
            });

        }  else setView('btn');
    }     


    const completeUpload1 = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);      
        setRow({...row, ["crypt1"]:crypt, ["nazwa1"]:fileName } ); 
    }

    const completeUpload2 = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);      
        setRow({...row, ["crypt2"]:crypt, ["nazwa2"]:fileName } ); 
    }    

    const completeUpload3 = (fileName, crypt) => {

        console.log("completeUpload " + fileName + " " + crypt);      
        setRow({...row, ["crypt3"]:crypt, ["nazwa3"]:fileName } ); 
    }   
 


    var dlg_view =  (

            <div className="dlg_window dlg_type_xx shadowx">

                    <div className="dlg_title">
                        Nowe zgłoszenie
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                     

                                        <div className="form_control">
                                            <div className="fieldName">Temat*</div>
                                            <InputText   userData={props.userData} value={row.temat} err={errTab}  valChange={valChangeListener} goNext={null} name="temat" placeholder={"Temat: np. Rozliczenia "} className=' w300 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_split"></div>


                                        <div className="form_control">
                                            <div className="fieldName">Treść*</div>
                                            <InputTextArea   userData={props.userData} value={row.tresc} err={errTab}  valChange={valChangeListener} goNext={null} name="tresc" placeholder={"Treść: Mam problem z... "} className=' w400 h200 ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">
                                                <InputUploader   userData={props.userData}  typ="none" typId="-1" remove="0" completeUpload={completeUpload1} title="dodaj załącznik [+]" max_files="1" ext="image/png, image/jpeg" />
                                                &nbsp; &nbsp; <b>{row.nazwa1}</b>    
                                            </div>                                                                               
                                        </div>

                                   

                                        <div className="form_split">                                       
                                        </div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>wyślij</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <div>
                <div className="btn"    onClick={changeView} >nowe zgłoszenie</div> 
                {dlg_view} 
           </div>
}


export default SupportNew;